import axios from 'axios';
import { get } from 'lodash';

export type ApartmentItemType = {
  kayitNo: number;
  bina: {
    kayitNo: number;
    csbm: {
      kayitNo: number;
      mahalle: {
        kayitNo: number;
        koy: {
          kayitNo: number;
          bucak: {
            kayitNo: number;
            ilce: {
              kayitNo: number;
              il: {
                kayitNo: number;
                ilKodu: number;
                ilAdi: string;
              };
              ilceKodu: number;
              ilceAdi: string;
            };
            bucakKodu: number;
            bucakAdi: string;
          };
          koyKodu: number;
          koyAdi: string;
        };
        mahalleAdi: string;
        mahalleKodu: number;
      };
      prmCsbmTurKod: {
        kod: number;
        aciklama: string;
      };
      csbmAdi: string;
      koordinatId: number;
      koordX: string;
      koordY: string;
    };
    siteAdi: string;
    blokAdi: string;
    postaKodu: string | null;
    binaNo: number;
    disKapiNo1: string;
    disKapiNo2: string | null;
  };
  icKapiNo1: string;
  icKapiNo2: string | null;
  adresNo: number;
};

const getApartmentList = async (kayitNo: string): Promise<ApartmentItemType[]> => {
  const url = `https://api.ibb.gov.tr/ibb-adres-api/adres/bina/bagimsizBolum/${kayitNo}`;

  const response = await axios.get(url);

  return get(response, 'data', []);
};

export default getApartmentList;
